var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',[_c('CustomerHeatMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }